import { Component, OnInit, Input } from '@angular/core';
import { RoomLayout } from '../../model/layout/Room.layout';
import { Room } from '../../model/interfaces';
import { CvdsUtilsService } from '../../service';

@Component({
	selector: 'cv-cvds-room',
	templateUrl: './cvds-room.component.html',
	styleUrls: ['../../cvds-structures.component.scss']
})
export class CvdsRoomComponent implements OnInit {
	@Input() room: Room;
	@Input() index: number;

	constructor(private utilsService: CvdsUtilsService) {}

	fieldsModel = [];
	fieldsSections = [];

	async ngOnInit(): Promise<void> {
		const layout = new RoomLayout();
		this.fieldsModel = this.utilsService.mapFields(this.room, layout.fields);

		layout.fieldsArray.forEach(item => {
			const { fieldName, label, fields } = item;
			if (Object.prototype.hasOwnProperty.call(this.room, fieldName)) {
				this.fieldsSections.push({
					items: this.room[fieldName],
					fields: fields,
					title: label
				});
			}
		});
	}
}
